const updatePincode = {
    "d": {
        IsSuccess: true
    }
};
export default updatePincode;